import { useState } from "react";

const faqs = [
  {
    question: "Dans quel délai peut-on compter sur une intervention à Haguenau ?",
    answer:
      "Haguenau se situe à une demi-heure de notre atelier de Strasbourg. Pour une demande en urgence, nous proposons généralement un créneau dans les 24 heures. Pour une réparation programmée, comptez 24 à 48 heures. Le déplacement et le diagnostic sont toujours gratuits, et vous recevez un devis précis avant le début des travaux.",
  },
  {
    question: "Y a-t-il des frais de déplacement pour venir de Strasbourg ?",
    answer:
      "Non, aucun frais de déplacement n'est facturé. Notre zone d'intervention couvre l'ensemble du Bas-Rhin, et Haguenau en fait partie. Le technicien arrive avec son stock de pièces, établit un diagnostic gratuit et vous remet un devis. Vous ne réglez que l'intervention réalisée, et seulement si vous acceptez le devis.",
  },
  {
    question: "Les fenêtres anciennes du centre d'Haguenau sont-elles réparables ?",
    answer:
      "Oui, et c'est même une de nos spécialités. Le centre d'Haguenau abrite de magnifiques maisons à colombages avec des fenêtres en bois traditionnelles. Nos techniciens connaissent les ferrures anciennes et les mécanismes modernes. Nous réparons aussi les fenêtres PVC des lotissements récents et les menuiseries aluminium des immeubles. Toutes les marques sont prises en charge : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Aubi, Cadiou.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Haguenau
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-rose-50 rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}